import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from "../../AxiosInstance/AxiosInstance";
import Cookies from "js-cookie";

const FinancialYear = Cookies.get("FinancialYear");
const Firm = Cookies.get("Firm");

const DataBase = Cookies.get("Database");

export const MasterFilterMain = createAsyncThunk('/PartyProfile/AccountList_Party_Pro', async (data) => {
    try {
        const response = await api.post(`/PartyProfile/AccountList_Party_Pro`, {
            FirmIDs: Firm,
            DataBase: DataBase,
            
            AcYearIDs: FinancialYear,
            ProductionGroupMstIDs: data,
            AcIDs: data ? data.id : "",
        }, );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const AccountToPGroupList = createAsyncThunk('/PartyProfile/Production_Group_List_Party_Pro', async (data) => {
    try {
        const response = await api.post(`/PartyProfile/Production_Group_List_Party_Pro`, {
            FirmIDs: Firm,
            DataBase: DataBase,
            
            AcYearIDs: FinancialYear,
            ProductionGroupMstIDs: "",
            AcIDs: data,
        }, );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const InwParty365 = createAsyncThunk('/PartyProfile/InwParty365', async (data) => {
    try {
        if (data.value === "pg") {
            const response = await api.post(`/PartyProfile/InwParty365`, {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                ProductionGroupMstIDs: data.id ? data.id : "",
            }, );

            return response.data;
        } else {
            const response = await api.post(`/PartyProfile/InwParty365`, {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                AcIDs: data.id ? data.id : "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
            }, );
            return response.data;
        }

    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const MulInwParty365 = createAsyncThunk('/PartyProfile/MulInwParty365', async (data) => {
    try {

        const response = await api.post(`/PartyProfile/InwParty365`, {
            FirmIDs: Firm,
            DataBase: DataBase,
            
            AcYearIDs: FinancialYear,
            AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
            ProductionGroupMstIDs: data.id ? data.id : ""
        }, );
        return response.data;

    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const InwQuality = createAsyncThunk('/PartyProfile/InwQuality', async (data) => {

    try {
        if (data.value === "pg") {
            const response = await api.post(`/PartyProfile/InwQuality`, {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                ProductionGroupMstIDs: data.id ? data.id : ""
            }, );
            return response.data;
        } else {
            const response = await api.post(`/PartyProfile/InwQuality`, {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
            }, );
            return response.data;
        }
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const MulInwQuality = createAsyncThunk('/PartyProfile/MulInwQuality', async (data) => {
    try {

        const response = await api.post(`/PartyProfile/InwQuality`, {
            FirmIDs: Firm,
            DataBase: DataBase,
            
            AcYearIDs: FinancialYear,
            AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
            ProductionGroupMstIDs: data.id ? data.id : ""
        }, );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const InwDatetail = createAsyncThunk('/PartyProfile/InwDate', async (data) => {

    try {
        if (data.value === "pg") {
            const response = await api.post(`/PartyProfile/InwDate`, {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                ProductionGroupMstIDs: data.id ? data.id : ""
            }, );
            return response.data;
        } else {
            const response = await api.post(`/PartyProfile/InwDate`, {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
            }, );
            return response.data;
        }

    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const MulInwDetail = createAsyncThunk('/PartyProfile/MulInwDatetail', async (data) => {
    try {
        const response = await api.post(`/PartyProfile/InwDate`, {
            FirmIDs: Firm,
            DataBase: DataBase,
            
            AcYearIDs: FinancialYear,
            AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
            ProductionGroupMstIDs: data.id ? data.id : ""
        }, );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const DlvParty365 = createAsyncThunk('/PartyProfile/DlvParty365', async (data) => {

    try {
        if (data.value === "pg") {
            const response = await api.post(`/PartyProfile/DlvParty365`, {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                ProductionGroupMstIDs: data.id ? data.id : ""
            }, );
            return response.data;
        } else {
            const response = await api.post(`/PartyProfile/DlvParty365`, {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
            }, );
            return response.data;

        }

    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const MulDlvParty365 = createAsyncThunk('/PartyProfile/MulDlvParty365', async (data) => {
    try {
        const response = await api.post(`/PartyProfile/DlvParty365`, {
            FirmIDs: Firm,
            DataBase: DataBase,
            
            AcYearIDs: FinancialYear,
            AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
            ProductionGroupMstIDs: data.id ? data.id : ""
        }, );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const DlvQuality = createAsyncThunk('/PartyProfile/DlvQuality', async (data) => {

    try {
        if (data.value === "pg") {
            const response = await api.post(`/PartyProfile/DlvQuality`, {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                ProductionGroupMstIDs: data.id ? data.id : ""
            }, );
            return response.data;
        } else {
            const response = await api.post(`/PartyProfile/DlvQuality`, {
                FirmIDs: Firm,
                AcYearIDs: FinancialYear,
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                DataBase: DataBase,
                
            }, );
            return response.data;
        }
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const MulDlvQuality = createAsyncThunk('/PartyProfile/MulDlvQuality', async (data) => {
    try {
        const response = await api.post(`/PartyProfile/DlvQuality`, {
            FirmIDs: Firm,
            DataBase: DataBase,
            
            AcYearIDs: FinancialYear,
            AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
            ProductionGroupMstIDs: data.id ? data.id : ""
        }, );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const DlvDetail = createAsyncThunk('/PartyProfile/DlvDate', async (data) => {

    try {
        if (data.value === "pg") {
            const response = await api.post(`/PartyProfile/DlvDate`, {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                ProductionGroupMstIDs: data.id ? data.id : ""
            }, );
            return response.data;
        } else {
            const response = await api.post(`/PartyProfile/DlvDate`, {
                FirmIDs: Firm,
                AcYearIDs: FinancialYear,
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
                DataBase: DataBase,
                
            }, );
            return response.data;
        }

    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const MulDlvDetail = createAsyncThunk('/PartyProfile/MulDlvDetail', async (data) => {
    try {
        const response = await api.post(`/PartyProfile/DlvDate`, {
            FirmIDs: Firm,
            DataBase: DataBase,
            
            AcYearIDs: FinancialYear,
            AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
            ProductionGroupMstIDs: data.id ? data.id : ""
        }, );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const BalParty365 = createAsyncThunk('/PartyProfile/BalParty365', async (data) => {

    try {
        if (data.value === "pg") {
            const response = await api.post(`/PartyProfile/BalParty365`, {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                ProductionGroupMstIDs: data.id ? data.id : ""
            }, );
            return response.data;
        } else {
            const response = await api.post(`/PartyProfile/BalParty365`, {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
            }, );
            return response.data;
        }

    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const MulBalParty365 = createAsyncThunk('/PartyProfile/MulBalParty365', async (data) => {
    try {
        const response = await api.post(`/PartyProfile/BalParty365`, {
            FirmIDs: Firm,
            DataBase: DataBase,
            
            AcYearIDs: FinancialYear,
            AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
            ProductionGroupMstIDs: data.id ? data.id : ""
        }, );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const BalQuality = createAsyncThunk('/PartyProfile/BalQuality', async (data) => {

    try {
        if (data.value === "pg") {
            const response = await api.post(`/PartyProfile/BalQuality`, {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                ProductionGroupMstIDs: data.id ? data.id : ""
            }, );
            return response.data;
        } else {
            const response = await api.post(`/PartyProfile/BalQuality`, {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
            }, );
            return response.data;
        }

    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const MulBalQuality = createAsyncThunk('/PartyProfile/MulBalQuality', async (data) => {
    try {
        const response = await api.post(`/PartyProfile/BalQuality`, {
            FirmIDs: Firm,
            DataBase: DataBase,
            
            AcYearIDs: FinancialYear,
            AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
            ProductionGroupMstIDs: data.id ? data.id : ""
        }, );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const BalDetail = createAsyncThunk('/PartyProfile/BalDate', async (data) => {

    try {
        if (data.value === "pg") {
            const response = await api.post(`/PartyProfile/BalDate`, {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                ProductionGroupMstIDs: data.id ? data.id : ""
            }, );
            return response.data;
        } else {
            const response = await api.post(`/PartyProfile/BalDate`, {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
                ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
            }, );
            return response.data;
        }

    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

export const MulBalDetail = createAsyncThunk('/PartyProfile/MulBalDetail', async (data) => {
    try {
        const response = await api.post(`/PartyProfile/BalDate`, {
            FirmIDs: Firm,
            DataBase: DataBase,
            
            AcYearIDs: FinancialYear,
            AcIDs: data.PARTYWISEIds ? data.PARTYWISEIds : "",
            ProductionGroupMstIDs: data.id ? data.id : ""
        }, );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Network Error');
    }
})

const PartyProfileSlice = createSlice({
    name: 'partyprofile',
    initialState: {
        MasterFilterData: null,
        AccountToPGroupListData: null,
        MulInwParty365Data: null,
        MulInwQualityData: null,
        MulInwDetailData: null,
        MulDlvParty365Data: null,
        MulDlvQualityData: null,
        MulDlvDetailData: null,
        MulBalParty365Data: null,
        MulBalQualityData: null,
        MulBalDetailData: null,
        InwParty365Data: null,
        InwQualityData: null,
        InwDatetailData: null,
        DlvParty365Data: null,
        DlvQualityData: null,
        DlvDetailData: null,
        Balance365Data: null,
        BalQualityData: null,
        BalDetailData: null,

        loading: false,
        masterLoading: false,
        AccountListLoding: false,

        error: null,
    },
    reducers: {



        resetMasterFilter: (state) => {
            state.MasterFilterData = null;
        },

        resetAccountToPGroupList: (state) => {
            state.AccountToPGroupListData = null;
        },

        // 🔹 INWARD
        resetInwParty365: (state) => {
            state.InwParty365Data = null;
        },

        resetMulInwParty365: (state) => {
            state.MulInwParty365Data = null;
        },

        resetInwQuality: (state) => {
            state.InwQualityData = null;
        },

        resetMulInwQuality: (state) => {
            state.MulInwQualityData = null;
        },

        resetInwDetail: (state) => {
            state.InwDatetailData = null;
        },

        resetMulInwDetail: (state) => {
            state.MulInwDetailData = null;
        },

        // 🔹 DELIVERY
        resetDlvParty365: (state) => {
            state.DlvParty365Data = null;
        },

        resetMulDlvParty365: (state) => {
            state.MulDlvParty365Data = null;
        },

        resetDlvQuality: (state) => {
            state.DlvQualityData = null;
        },

        resetMulDlvQuality: (state) => {
            state.MulDlvQualityData = null;
        },

        resetDlvDetail: (state) => {
            state.DlvDetailData = null;
        },

        resetMulDlvDetail: (state) => {
            state.MulDlvDetailData = null;
        },

        // 🔹 BALANCE
        resetBalParty365: (state) => {
            state.Balance365Data = null;
        },

        resetMulBalParty365: (state) => {
            state.MulBalParty365Data = null;
        },

        resetBalQuality: (state) => {
            state.BalQualityData = null;
        },

        resetMulBalQuality: (state) => {
            state.MulBalQualityData = null;
        },

        resetBalDetail: (state) => {
            state.BalDetailData = null;
        },

        resetMulBalDetail: (state) => {
            state.MulBalDetailData = null;
        },


    },
    extraReducers: (builder) => {
        builder
            .addCase(MasterFilterMain.pending, (state) => {
                state.masterLoading = true;
            })
            .addCase(MasterFilterMain.fulfilled, (state, action) => {
                state.masterLoading = false;
                state.MasterFilterData = action.payload;
            })
            .addCase(MasterFilterMain.rejected, (state) => {
                state.masterLoading = false;
            })

            .addCase(InwParty365.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(InwParty365.fulfilled, (state, action) => {
                state.loading = false;
                state.InwParty365Data = action.payload;
            })
            .addCase(InwParty365.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })

            .addCase(MulInwParty365.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(MulInwParty365.fulfilled, (state, action) => {
                state.loading = false;
                state.MulInwParty365Data = action.payload;
            })
            .addCase(MulInwParty365.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })

            .addCase(MulInwQuality.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(MulInwQuality.fulfilled, (state, action) => {
                state.loading = false;
                state.MulInwQualityData = action.payload;
            })
            .addCase(MulInwQuality.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })

            .addCase(MulInwDetail.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(MulInwDetail.fulfilled, (state, action) => {
                state.loading = false;
                state.MulInwDetailData = action.payload;
            })
            .addCase(MulInwDetail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })

            .addCase(MulDlvParty365.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(MulDlvParty365.fulfilled, (state, action) => {
                state.loading = false;
                state.MulDlvParty365Data = action.payload;
            })
            .addCase(MulDlvParty365.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })


            .addCase(MulDlvQuality.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(MulDlvQuality.fulfilled, (state, action) => {
                state.loading = false;
                state.MulDlvQualityData = action.payload;
            })
            .addCase(MulDlvQuality.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })

            .addCase(MulDlvDetail.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(MulDlvDetail.fulfilled, (state, action) => {
                state.loading = false;
                state.MulDlvDetailData = action.payload;
            })
            .addCase(MulDlvDetail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })

            .addCase(MulBalParty365.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(MulBalParty365.fulfilled, (state, action) => {
                state.loading = false;
                state.MulBalParty365Data = action.payload;
            })
            .addCase(MulBalParty365.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })


            .addCase(MulBalQuality.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(MulBalQuality.fulfilled, (state, action) => {
                state.loading = false;
                state.MulBalQualityData = action.payload;
            })
            .addCase(MulBalQuality.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })

            .addCase(MulBalDetail.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(MulBalDetail.fulfilled, (state, action) => {
                state.loading = false;
                state.MulBalDetailData = action.payload;
            })
            .addCase(MulBalDetail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })

            .addCase(InwQuality.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(InwQuality.fulfilled, (state, action) => {
                state.loading = false;
                state.InwQualityData = action.payload;
            })
            .addCase(InwQuality.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })

            .addCase(InwDatetail.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(InwDatetail.fulfilled, (state, action) => {
                state.loading = false;
                state.InwDatetailData = action.payload;
            })
            .addCase(InwDatetail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })

            .addCase(DlvParty365.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(DlvParty365.fulfilled, (state, action) => {
                state.loading = false;
                state.DlvParty365Data = action.payload;
            })
            .addCase(DlvParty365.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })

            .addCase(DlvQuality.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(DlvQuality.fulfilled, (state, action) => {
                state.loading = false;
                state.DlvQualityData = action.payload;
            })
            .addCase(DlvQuality.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })

            .addCase(DlvDetail.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(DlvDetail.fulfilled, (state, action) => {
                state.loading = false;
                state.DlvDetailData = action.payload;
            })
            .addCase(DlvDetail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })

            .addCase(BalParty365.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(BalParty365.fulfilled, (state, action) => {
                state.loading = false;
                state.Balance365Data = action.payload;
            })
            .addCase(BalParty365.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })

            .addCase(BalQuality.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(BalQuality.fulfilled, (state, action) => {
                state.loading = false;
                state.BalQualityData = action.payload;
            })
            .addCase(BalQuality.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })

            .addCase(BalDetail.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(BalDetail.fulfilled, (state, action) => {
                state.loading = false;
                state.BalDetailData = action.payload;
            })
            .addCase(BalDetail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })

            .addCase(AccountToPGroupList.pending, (state) => {
                state.AccountListLoding = true;
                state.error = null;
            })
            .addCase(AccountToPGroupList.fulfilled, (state, action) => {
                state.AccountListLoding = false;
                state.AccountToPGroupListData = action.payload;
            })
            .addCase(AccountToPGroupList.rejected, (state, action) => {
                state.AccountListLoding = false;
                state.error = action.payload || action.error.message;
            })
    },
});


export default PartyProfileSlice.reducer;

export const {
    resetMasterFilter,
    resetAccountToPGroupList,

    resetInwParty365,
    resetMulInwParty365,
    resetInwQuality,
    resetMulInwQuality,
    resetInwDetail,
    resetMulInwDetail,

    resetDlvParty365,
    resetMulDlvParty365,
    resetDlvQuality,
    resetMulDlvQuality,
    resetDlvDetail,
    resetMulDlvDetail,

    resetBalParty365,
    resetMulBalParty365,
    resetBalQuality,
    resetMulBalQuality,
    resetBalDetail,
    resetMulBalDetail

} = PartyProfileSlice.actions;